import { Box } from "@chakra-ui/react"

import ReminderForm from '../reminder/ReminderForm'
import Sidebar  from '../sidebar/Sidebar'
import { useMediaQuery } from '@chakra-ui/react'

const Layout = ({children}) => {
	const [isMobile] = useMediaQuery('(max-width: 480px)')
	return isMobile ? <ReminderForm/> : (
	<Box height="100%" display={'flex'}>
		<Sidebar/>
		<Box overflow='auto' w="full" position="relative">
			{children}
		</Box>
	</Box>
)
}
export default Layout
